import React, {PureComponent} from "react";
import MainFrame from "./MainFrame";
import {Helmet} from "react-helmet-async";
import Nav from "./Nav";
import QRVirus from "./QRVirus";
import {setPropertyPx} from "./library";
import ErrorBoundary from "./ErrorBoundary";
import Apollo from "./Apollo";

const DONT_COPY = new Set(["pages"])

const page_class = {
    MainFrame, QRVirus, Apollo
}


class PhotoShell extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            dimensions: {
                "navWidth": 50
            },
        }
        this.childAdaptMethod = undefined
    }

    componentDidMount = async () => {
        window.addEventListener("resize", this.adaptToSize)
        this.adaptToSize()
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.adaptToSize)
    }

    adaptToSize = () => {
        const {navWidth} = this.state.dimensions
        setPropertyPx('--innerHeight', window.innerHeight);
        setPropertyPx('--navWidth', navWidth);
        const articleWidth = window.innerWidth - navWidth;
        setPropertyPx('--articleWidth', articleWidth)
        if(this.childAdaptMethod) {
            this.childAdaptMethod({navWidth, articleWidth})
        }
    }

    registerAdapt = (childAdaptMethod) => {
        this.childAdaptMethod = childAdaptMethod
        this.adaptToSize()
    }

    render = () => {
        const { dimensions } = this.state
        const { pathname, hash, config } = this.props
        const { title } = config

        const entries = this.configureEntries()
        const hashTable = this.makeHashTable(entries)
        const visiblePageIndex = hashTable[hash ? hash: "#"]
        const visiblePageName = entries[visiblePageIndex].name

        const innerConfig = this.configureVisiblePage(visiblePageIndex)
        const Page = page_class[innerConfig.page]

        return <main>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Nav entries={entries} visiblePageName={visiblePageName} />
            <ErrorBoundary key={visiblePageIndex}>
                <Page
                    config={innerConfig}
                    pathname={pathname}
                    dimensions={dimensions}
                    registerAdapt={this.registerAdapt}
                    adaptToSize={this.adaptToSize}
                />
            </ErrorBoundary>
        </main>;
    }

    configureVisiblePage(visiblePageIndex) {
        const { config } = this.props
        const { pages } = config

        const innerConfig = {...pages[visiblePageIndex]}
        for (const k in config) {
            if (!DONT_COPY.has(k)) {
                if (!(k in innerConfig)) {
                    innerConfig[k] = config[k]
                }
            }
        }
        return innerConfig;
    }

    configureEntries() {
        const { config } = this.props
        const { pages } = config

        const entries = []
        for(let i=0;i<pages.length;i++) {
            const no = i+1
            entries.push({
                hash: no === 1 ? "#" : "#"+no,
                name: no.toString(),
                tooltip: pages[i].tooltip ?? page_class[pages[i].page].page_title
            })
        }
        return entries
    }

    makeHashTable(entries) {
        const table = {}
        for(let i=0;i<entries.length;i++) {
            table[entries[i].hash] = i
        }
        return table
    }
}

export default PhotoShell;
